import { useEffect, useState } from "react";

const _SUBS_STATUS_CLS = {
  1: "active",
  2: "cancelled",
  4: "paused",
  5: "expired"
}

const _ORDER_STATUS_CLS = {
  1: "success",
  2: "unprocessed",
  3: "skipped",
  4: "failed",
  5: "processing"
}

const FINANCIAL_STATUS_KEY_CLASS_MAP = {
  "pending" : "pending",
  "authorized": "authorized",
  "partially_paid": "partially-paid",
  "partially_refunded": "partially-refunded",
  "refunded": "refunded",
  "voided": "voided",
}


function getLabelClass(entity: any, dbStatus: any, variant = null, size = null, financialStatus= null) {
  let key = "loop-label";
  if (entity && (dbStatus || variant)) {
    if (entity == "subscription" && dbStatus in _SUBS_STATUS_CLS) {
      key += "-" + entity + "-" + _SUBS_STATUS_CLS[dbStatus]
    } else if (entity == "order" && dbStatus in _ORDER_STATUS_CLS) {
      if(financialStatus && financialStatus !== 'paid'){
        key += "-" + entity + "-" + "financial-status-" + FINANCIAL_STATUS_KEY_CLASS_MAP[financialStatus];
      } else {
        key += "-" + entity + "-" + _ORDER_STATUS_CLS[dbStatus]
      }
    } else if (entity == "line") {
      key += "-" + entity
    } else if (entity == "payment-method") {
      key += "-" + entity + "-" + variant
    }
  }
  if (variant) {
    key += " loop-label-variant-" + variant
  }
  if (size) {
    key += " loop-label-size-" + size
  }
  return key;
}

function Label(props: any) {
  const [className, setclassName] = useState("");
  useEffect(() => {
    let _className = getLabelClass(props.entity, props.dbStatus, props.variant, props.size, props.financialStatus);
    if (props.className) {
      _className += " " + props.className
    }
    setclassName(_className)
  }, [props.className])
  return (
    <div className={className}>{props.title}</div>
  );
}

export default Label;
